import { css } from 'styled-components'

import { safeParseCoords } from '../formControls/Coords/utils'
import { applySize } from '../formControls/Size/utils'
import type { INodeV2StyledProps } from './NodeV2Styled'

const Coords = (coords: string | undefined) => {
  const { top, left, right, bottom } = safeParseCoords(coords)
  return css`
    ${typeof top === 'number' && `top: ${top}px;`}
    ${typeof left === 'number' && `left: ${left}px;`}
  ${typeof right === 'number' && `right: ${right}px;`}
  ${typeof bottom === 'number' && `bottom: ${bottom}px;`}
  `
}

const AbsoluteItemStyled = ({ $style }: INodeV2StyledProps) => css`
  position: absolute;
  z-index: ${$style?.zIndex || 1};

  min-width: ${applySize($style?.minWidth)};
  width: ${applySize($style?.width)};
  max-width: ${applySize($style?.maxWidth)};
  min-height: ${applySize($style?.minHeight)};
  height: ${applySize($style?.height)};
  max-height: ${applySize($style?.maxHeight)};

  ${Coords($style?.coords)};
`

export default AbsoluteItemStyled
